import { render, staticRenderFns } from "./VisitCreateFormComponent.vue?vue&type=template&id=52af2bbc&scoped=true"
import script from "./VisitCreateFormComponent.vue?vue&type=script&lang=ts"
export * from "./VisitCreateFormComponent.vue?vue&type=script&lang=ts"
import style0 from "./VisitCreateFormComponent.vue?vue&type=style&index=0&id=52af2bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52af2bbc",
  null
  
)

export default component.exports